import {Box, Flex, Icon, Text, keyframes} from '@chakra-ui/react'
import {ReactComponent as CheckCircleIcon} from '@assets/svgs/check_circle.svg'

const slideUp = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`

const Intro = ({currentContent}: {currentContent: any}) => {
  const animation = `${slideUp} 0.5s ease-out`

  return (
    <Box ml={'200px'} pt={'24px'} animation={animation}>
      <Text color={'#007EF5'} marginBottom={'16px'} fontSize={'16px'}>
        {currentContent?.data?.question_title.toUpperCase()}
      </Text>
      <Flex flexDirection={'column'} gap={'16px'}>
        {currentContent?.data?.suggest_question.map(
          (item: any, index: number) => (
            <Flex key={index} gap={'12px'} alignItems={'start'}>
              <Icon
                as={CheckCircleIcon}
                color={'#007EF5'}
                w={'24px'}
                h={'24px'}
                sx={{path: {stroke: '#98A2B3 '}}}
              />
              <Box>
                <Text fontWeight={500} color={'#101828'} fontSize={'18px'}>
                  {item.text_en}
                </Text>
                <Text fontSize={'16px'} color={'#475467'}>
                  {item.text_vi}
                </Text>
              </Box>
            </Flex>
          ),
        )}
      </Flex>
    </Box>
  )
}

export default Intro
